// ────────────────────────────────────────────────────────────────────
// ValidationCaveat — the standing "these numbers aren't signed off yet"
// notice shown to clients across every screen (mounted once in AppShell).
// Engine-computed integrity values (corrosion rate, remaining life, RBI) are
// preliminary until a Level III inspector signs them off; this guarantees the
// baseline caveat is present everywhere a client reads a number. The wording
// lives here once — report.html reuses the same text for exported reports.
// ────────────────────────────────────────────────────────────────────
import { AlertTriangle } from "lucide-react";

export const VALIDATION_CAVEAT =
  "Preliminary — engine-computed values, not yet verified by a Level III inspector. Not for final decisions without sign-off.";

// `status` is the seam for a future Level III sign-off workflow (Option B): when a
// record becomes verified it will render a certification line instead. Ignored today.
export function ValidationCaveat({ status }: { status?: string }): JSX.Element {
  void status;
  return (
    <div className="shrink-0 flex items-center gap-2 px-5 h-6 border-t font-mono"
         style={{ fontSize: 10, letterSpacing: ".04em", background: "rgba(217,119,6,0.10)",
                  borderColor: "rgba(217,119,6,0.35)", color: "var(--warn)" }}>
      <AlertTriangle size={11} className="shrink-0" />
      <span className="truncate">{VALIDATION_CAVEAT}</span>
    </div>
  );
}
